"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_aria_1 = require("react-aria");
const Icon_1 = require("../Icons/Icon");
/*
  This has to be a separate element otherwise the focus trap fails. Assuming this is because it needs
  to fit inside the 'Overlay' as a form of context.
*/
function PreviewModalContent({ children, onClose, ...props }) {
    const ref = (0, react_1.useRef)(null);
    const { dialogProps, titleProps } = (0, react_aria_1.useDialog)(props, ref);
    return (react_1.default.createElement("div", { ...dialogProps, ref: ref, className: "h-full flex flex-col" },
        react_1.default.createElement("h3", { ...titleProps, className: "sr-only" }, "Resource Details"),
        react_1.default.createElement("button", { type: "button", "aria-label": "Close details", onClick: onClose, className: "absolute top-3 right-3" },
            react_1.default.createElement(Icon_1.Icon, { icon: 'close', className: "" })),
        children));
}
// Accept a ref for the top level modal
function PreviewModal({ state, overlayProps, children, onClose, ...props }) {
    const modalRef = (0, react_1.useRef)(null);
    const overlayRef = (0, react_1.useRef)(null);
    const { modalProps, underlayProps } = (0, react_aria_1.useModalOverlay)({ isKeyboardDismissDisabled: true, ...props }, state, overlayRef);
    // Need to handle the ESC escape hatch ourselves as we need to run onClose to deselect the current node
    const { keyboardProps } = (0, react_aria_1.useKeyboard)({
        onKeyDown: (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
            else {
                // Need to do this so TAB get handled up higher and cycles though the focus trap
                e.continuePropagation();
            }
        },
    });
    (0, react_1.useEffect)(() => {
        // Check if the click event has happened outside the modal
        function handleClickOutside(event) {
            if (modalRef.current && !modalRef.current.contains(event?.target)) {
                onClose();
            }
        }
        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [modalRef]);
    return (react_1.default.createElement(react_aria_1.Overlay, null,
        react_1.default.createElement("div", { className: "squiz-gb-scope" },
            react_1.default.createElement("div", { ref: modalRef, ...underlayProps, ...keyboardProps, className: "fixed z-[9999] overflow-y-scroll bottom-0 w-full h-[50vh] bg-white border-t border-gray-300" },
                react_1.default.createElement("div", { ref: overlayRef, ...modalProps, className: "h-full" },
                    react_1.default.createElement(PreviewModalContent, { ...overlayProps, onClose: onClose }, children))))));
}
exports.default = PreviewModal;
